import React from 'react';

const CTASection = () => {
  return (
    <div className="text-center px-6 py-8 border-t border-gray-800 w-full">
      <p className="text-gray-400 mb-6 text-lg">
        Ha szeretne ügyfelünk lenni, érdeklődjön elérhetőségeink egyikén!
      </p>
      <div className="flex flex-col space-y-4">
        <a 
          href="tel:+36709083086"
          className="text-xl text-purple-400 hover:text-purple-300 transition-colors duration-300 flex items-center justify-center"
        >
          <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
          </svg>
          +36 70 908 3086
        </a>
        <a 
          href="mailto:support@webforyou.hu"
          className="text-xl text-purple-400 hover:text-purple-300 transition-colors duration-300 flex items-center justify-center"
        >
          <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
          support@webforyou.hu
        </a>
      </div>
    </div>
  );
};

export default CTASection;